<script>
    import {afterUpdate, onMount} from 'svelte';
    import {Router, Route} from "svelte-routing";
    import NavLink from "./components/NavLink.svelte";
    import {flashError, flashSuccess, userFeatures} from "./components/stores.js";

    import Footer from './Footer.svelte'
    // Pages
    import Blog from './components/Blog.svelte'
    import Ajankohtaista from './components/Ajankohtaista.svelte'
    import Treenivinkit from './components/Treenivinkit.svelte'
    import Gym from './pages/Gym.svelte'
    import Pricing from './pages/Pricing.svelte'
    import Workouts from './pages/Workouts.svelte'
    import Front from './pages/Front.svelte'
    import EventCalendar from "./components/EventCalendar.svelte";
    import StartTraining from './pages/StartTraining.svelte'
    import Family from './pages/Family.svelte'
    import Contract from './pages/Contract.svelte'
    import WorkoutNames from "./pages/WorkoutNames.svelte";
    import Services from "./pages/Services.svelte";
    import Coaches from "./pages/Coaches.svelte";
    import Groups from "./pages/Groups.svelte";
    import MassageMaija from "./pages/MassageMaija.svelte";
    import SportClubs from "./pages/SportClubs.svelte";
    import References from "./pages/References.svelte";
    import Kaski from "./pages/Kaski.svelte";
    import SingleVisit from "./pages/SingleVisit.svelte";
    import FridayLeague from "./pages/FridayLeague.svelte";


    import LoginForm from "./pages/customer/LoginForm.svelte";
    import ForgotPasswordForm from "./pages/customer/ForgotPasswordForm.svelte";
    import NewPasswordForm from "./pages/customer/NewPasswordForm.svelte";
    import CustomerHome from "./pages/customer/CustomerHome.svelte";
    import GenerateWod from "./pages/customer/GenerateWod.svelte";
    import OldGeneratedWods from "./pages/customer/OldGeneratedWods.svelte";
    import MaxLifts from "./pages/customer/MaxLifts.svelte";
    import Fasting from "./pages/customer/Fasting.svelte";
    import FinStats from "./pages/customer/FinStats.svelte";
    import DailyMeal from "./pages/customer/DailyMeal.svelte";
    import MealHistory from "./pages/customer/MealHistory.svelte";
    import Goals from "./pages/customer/Goals.svelte";
    import GroupTraining from "./pages/customer/GroupTraining.svelte";
    import Logout from "./pages/customer/Logout.svelte";


    import PrivacyPolicy from './pages/PrivacyPolicy.svelte';
    import {encodeFeatureName, searchElementFromElementsOfArray} from "./components/utils";
    //const blogTexts = __myapp.env.blogTexts;

    // Kun käyttäjä on kirjautunut sisään, niin näytetään eri headeri
    let loggedIn = false;

    onMount(async () => {
        // Blog = import('./blog/'+blogTexts[0]).then(res => Blog = res.default);
        //console.log("blogTexts" , Blog)
        //bjson = import('./blog/'+blogTexts[2]);
        //bjson = (await import('./blog/'+blogTexts[2]));
        //console.log("bjson" , bjson, blogTexts);

        // Päätellään, ollaanko kirjautuneena
        let pageUrl = window.location.href
        if (pageUrl.includes("/c/")) {
            loggedIn = true;
        }
        console.log("onMount :: pageUrl", pageUrl);

    });

    export let url = "";

    let mainMenuElement = ""; // "main-menu
    let subNaviClass = ""; // subNavUl
    let mainMenuId = "mymenu";// "cssmenu";
    let mobileMenuIconClass = "hide";

    function openMenu() {
        if (mobileMenuIconClass === "hide") {
            mobileMenuIconClass = "show";
        } else {
            mobileMenuIconClass = "hide";
        }
    }


</script>

<div class="content-container">
    <Router url="{url}" basepath="">
        {#if loggedIn}
            <header class="header-main">
                <div class="nav-wrapper">
                    <div class="headerLogoContainer">
                        <a href="/">
                        <span class="logo">
                            <img height="100" width="175" src="/svelte-site/img/logo.png" alt="Dynamosali"
                                 title=""
                                 style="max-height: 88px;">
                        </span>
                        </a>
                    </div>
                    <div class="my-nav">
                        <!-- Normi menu kirjautuneille -->
                        <nav class="{mainMenuElement}" id="{mainMenuId}">
                            <ul>
                                <li class="mainPageLink">
                                    <NavLink to="/c/home">Omat tiedot</NavLink>
                                </li>
                                <!-- Pitää olla vähintään päiväntreenit enabloituna, että näytetään valikko -->
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                <li class="mainPageLink menuDropdown">
                                    <NavLink dropClass="dropbtn" to="/c/groupTrainings">Treenit</NavLink>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('ryhmatreeni'), $userFeatures)}
                                            <li>
                                                <NavLink to="/c/groupTrainings">Viimeisimmät ryhmätreenit</NavLink>
                                            </li>
                                        {/if}
                                        {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                            <li>
                                                <NavLink to="/c/oldGeneratedWods">Vanhat generoidut treeni</NavLink>
                                            </li>
                                        {/if}
                                        {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                            <li>
                                                <NavLink to="/c/gen">Generoi treeni</NavLink>
                                            </li>
                                        {/if}
                                        {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('maksiminostot'), $userFeatures)}
                                            <li>
                                                <NavLink to="/c/maxLifts">Maksiminostot</NavLink>
                                            </li>
                                        {/if}
                                    </ul>
                                </li>
                                {/if}
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('ruokapaivakirja'), $userFeatures)}
                                    <li class="mainPageLink menuDropdown">
                                        <NavLink dropClass="dropbtn" to="/c/fin">Hyvinvoiti</NavLink>
                                        <ul class="menuDropdownContent {subNaviClass}">
                                            <li>
                                                <NavLink to="/c/finStats">Edistys</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/c/finDailyMeals">Päivän ruuat</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/c/finHistory">Aiemmat ruuat</NavLink>
                                            </li>
                                            {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paastoaikalaskuri'), $userFeatures)}
                                                <NavLink to="/c/fasting">Paastoaikalaskuri</NavLink>
                                            {/if}
                                            <li>
                                                <NavLink to="/c/finGoals">Omat tavoitteet</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                {/if}
                                <li class="mainPageLink">
                                    <NavLink to="/c/logout">Kirjaudu ulos</NavLink>
                                </li>
                            </ul>
                        </nav>
                        <!-- Mobiilimenu -->
                        <nav id="hiddenMenu" class="{mobileMenuIconClass}" on:click={() => openMenu()}>
                            <ul>
                                <li><a href="/c/home">Omat tiedot</a></li>
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                    <li class="menuDropdown">
                                        <NavLink dropClass="dropbtn" to="/c/groupTrainings">Treenit</NavLink>
                                        <ul class="menuDropdownContent {subNaviClass}">
                                            {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('ryhmatreeni'), $userFeatures)}
                                                <li>
                                                    <NavLink to="/c/groupTrainings">Viimeisimmät ryhmätreenit</NavLink>
                                                </li>
                                            {/if}
                                            {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                                <li>
                                                    <NavLink to="/c/oldGeneratedWods">Vanhat generoidut treeni</NavLink>
                                                </li>
                                            {/if}
                                            {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                                <li>
                                                    <NavLink to="/c/gen">Generoi treeni</NavLink>
                                                </li>
                                            {/if}
                                            {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('maksiminostot'), $userFeatures)}
                                                <li>
                                                    <NavLink to="/c/maxLifts">Maksiminostot</NavLink>
                                                </li>
                                            {/if}
                                        </ul>
                                    </li>
                                {/if}
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('ryhmatreeni'), $userFeatures)}
                                    <li><a href="/c/groupTrainings">Viimeisimmät ryhmätreenit</a></li>
                                {/if}

                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paivantreeni'), $userFeatures)}
                                    <li><a href="/c/gen">Generoi treeni</a></li>
                                {/if}
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('paastoaikalaskuri'), $userFeatures)}
                                    <li><a href="/c/fasting">Paastoaikalaskuri</a></li>
                                {/if}
                                {#if $userFeatures && searchElementFromElementsOfArray('feature', encodeFeatureName('ruokapaivakirja'), $userFeatures)}
                                    <li class="menuDropdown">
                                        <a href="/c/fin">Hyvinvoiti</a>
                                        <ul class="menuDropdownContent {subNaviClass}">
                                            <li>
                                                <a href="/c/stats">Edistys</a>
                                            </li>
                                            <li>
                                                <a href="/c/finDailyMeal">Päivän ruuat</a>
                                            </li>
                                            <li>
                                                <a href="/c/finHistory">Aiemmat ruuat</a>
                                            </li>
                                            <li>
                                                <a href="/c/finSettings">Omat tavoitteet</a>
                                            </li>
                                        </ul>
                                    </li>
                                {/if}
                                <a href="/c/logout">Kirjaudu ulos</a>
                            </ul>
                        </nav>
                        <div id="myMobileMenuIcon">
                            <button id="menu_toggle" class="icon-menu" on:click={openMenu}>
                                <svg fill="#000000" height="16px" width="24px" version="1.1" id="Layer_1"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     viewBox="0 0 150 150" xml:space="preserve">
                            <g id="XMLID_240_">
                                <path id="XMLID_241_"
                                      d="M15,30h120c8.284,0,15-6.716,15-15s-6.716-15-15-15H15C6.716,0,0,6.716,0,15S6.716,30,15,30z"/>
                                <path id="XMLID_242_"
                                      d="M135,60H15C6.716,60,0,66.716,0,75s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,60,135,60z"/>
                                <path id="XMLID_243_"
                                      d="M135,120H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,120,135,120z"/>
                            </g>
                            </svg>
                                <span class="hidden">Valikko</span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        {:else}
            <header class="header-main">
                <div class="nav-wrapper">
                    <div class="headerLogoContainer">
                        <a href="/">
                        <span class="logo">
                            <img height="100" width="175" src="/svelte-site/img/logo.png" alt="Dynamosali"
                                 title=""
                                 style="max-height: 88px;">
                        </span>
                        </a>
                    </div>
                    <div class="my-nav">
                        <!-- Normi menu -->
                        <nav class="{mainMenuElement}" id="{mainMenuId}">
                            <ul>
                                <li class="mainPageLink">
                                    <NavLink to="/ajankohtaista">Ajankohtaista</NavLink>
                                </li>
                                <li class="mainPageLink">
                                    <NavLink to="/blog">Blogi</NavLink>
                                </li>
                                <!--      <li class="mainPageLink"><NavLink to="/treenivinkit">Treenivinkit</NavLink></li> -->
                                <li class="mainPageLink">
                                    <NavLink to="/kuntosali">Kuntosali</NavLink>
                                </li>
                                <li class="mainPageLink menuDropdown">
                                    <NavLink dropClass="dropbtn" to="/treenit-aukioloajat">Treenit</NavLink>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        <li>
                                            <NavLink to="/aloittaminen">Aloittaminen</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/perheet">Lapset ja perheet salilla</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/treenisanasto">Treenisanasto</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/sopimusehdot">Sopimusehdot</NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li class="mainPageLink">
                                    <NavLink to="/hinnasto">Hinnasto</NavLink>
                                </li>
                                <!-- TODO: Kaikki sivut kaipaa päivitystä, niin laitettiin toistaiseksi piiloon. Nostetaan esille kunhan on päivitetty -->
                                <li class="mainPageLink menuDropdown" style="display:none">
                                    <NavLink to="/palvelut">Palvelut</NavLink>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        <li>
                                            <NavLink to="/valmennustiimi">Valmennustiimi</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/tilausryhmat">Tilausryhmille</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/urheiluseurat">Urheiluseuroille</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/referenssit">Referenssit</NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li class="mainPageLink">
                                    <NavLink to="/hieronta">Hieronta</NavLink>
                                </li>
                                <li class="mainPageLink">
                                    <a target="_blank" href="https://holvi.com/shop/dynamosali">Verkkokauppa</a>
                                </li>
                            </ul>
                        </nav>
                        <!-- Mobiilimenu -->
                        <nav id="hiddenMenu" class="{mobileMenuIconClass}">
                            <ul>
                                <li><a href="/ajankohtaista">Ajankohtaista</a></li>
                                <li><a href="/blog">Blogi</a></li>
                                <!--         <li><a href="/treenivinkit">Treenivinkit</a></li> -->
                                <li><a href="/kuntosali">Kuntosali</a></li>
                                <li><a href="/hinnasto">Hinnasto</a></li>
                                <li class="menuDropdown">
                                    <a href="/treenit-aukioloajat" dropClass="dropbtn">Treenit ja aukioloajat</a>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        <li>
                                            <a href="/aloittaminen">Aloittaminen</a>
                                        </li>
                                        <li>
                                            <a href="/perheet">Lapset ja perheet salilla</a>
                                        </li>
                                        <li>
                                            <a href="/treenisanasto">Treenisanasto</a>
                                        </li>
                                        <li>
                                            <a href="/sopimusehdot">Sopimusehdot</a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- TODO: Piilotettu nyt myös mobiilinäkymästä -->
                                <li class="menuDropdown" style="display:none">
                                    <a href="/palvelut">Palvelut</a>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        <li>
                                            <a href="/valmennustiimi">Valmennustiimi</a>
                                        </li>
                                        <li>
                                            <a href="/tilausryhmat">Tilausryhmille</a>
                                        </li>
                                        <li>
                                            <a href="/urheiluseurat">Urheiluseuroille</a>
                                        </li>
                                        <li>
                                            <a href="/referenssit">Referenssit</a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a href="/hieronta">Hieronta</a></li>
                                <!--
                                <li class="menuDropdown">
                                    <a href="/hieronta">Hieronta</a>
                                    <ul class="menuDropdownContent {subNaviClass}">
                                        <li>
                                            <a target="_blank" href="https://vello.fi/urheiluhierojatuomasolli/dynamosali-kempele---urheiluhieroja-tuomas-olli">Ajanvaraus</a>
                                        </li>
                                    </ul>
                                </li>
                            -->
                                <li><a href="https://holvi.com/shop/dynamosali">Verkkokauppa</a></li>
                            </ul>
                        </nav>
                        <div id="myMobileMenuIcon">
                            <button id="menu_toggle" class="icon-menu" on:click={openMenu}>
                                <svg fill="#000000" height="16px" width="24px" version="1.1" id="Layer_1"
                                     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     viewBox="0 0 150 150" xml:space="preserve">
                            <g id="XMLID_240_">
                                <path id="XMLID_241_"
                                      d="M15,30h120c8.284,0,15-6.716,15-15s-6.716-15-15-15H15C6.716,0,0,6.716,0,15S6.716,30,15,30z"/>
                                <path id="XMLID_242_"
                                      d="M135,60H15C6.716,60,0,66.716,0,75s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,60,135,60z"/>
                                <path id="XMLID_243_"
                                      d="M135,120H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,120,135,120z"/>
                            </g>
                            </svg>
                                <span class="hidden">Valikko</span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        {/if}
        {#if $flashError != null}
            <div class="flash-message-container alert alert-danger" role="alert">{$flashError}</div>
        {/if}
        {#if $flashSuccess != null}
            <div class="flash-message-container alert alert-success" role="alert">{$flashSuccess}</div>
        {/if}
        <Route path="/">
            <Front/>
        </Route>
        <Route path="/ajankohtaista">
            <Ajankohtaista/>
        </Route>
        <Route path="ajankohtaista/:ajankohtaistaUrl" let:params>
            <Ajankohtaista ajankohtaistaUrl={params.ajankohtaistaUrl}/>
        </Route>
        <Route path="/blog">
            <Blog/>
        </Route>
        <Route path="/treenivinkit">
            <Treenivinkit/>
        </Route>
        <Route path="/treenivinkit/:treenivinkitUrl" let:params>
            <Treenivinkit treenivinkitUrl={params.treenivinkitUrl}/>
        </Route>
        <Route path="/kuntosali">
            <Gym/>
        </Route>
        <Route path="blog/:blogUrl" let:params>
            <Blog blogUrl={params.blogUrl}/>
        </Route>
        <Route path="/hinnasto">
            <Pricing/>
        </Route>
        <Route path="/treenisanasto">
            <WorkoutNames/>
        </Route>
        <Route path="/treenit-aukioloajat">
            <EventCalendar/>
            <Workouts/>
        </Route>
        <Route path="/aloittaminen">
            <StartTraining/>
        </Route>
        <Route path="/perheet">
            <Family/>
        </Route>
        <Route path="/sopimusehdot">
            <Contract/>
        </Route>
        <Route path="/rekisteriseloste">
            <PrivacyPolicy/>
        </Route>
        <Route path="/palvelut">
            <Services/>
        </Route>
        <Route path="/hieronta">
            <MassageMaija/>
        </Route>
        <Route path="/valmennustiimi">
            <Coaches/>
        </Route>
        <Route path="/tilausryhmat">
            <Groups/>
        </Route>
        <Route path="/urheiluseurat">
            <SportClubs/>
        </Route>
        <Route path="/referenssit">
            <References/>
        </Route>
        <Route path="/kaski">
            <Kaski/>
        </Route>
        <Route path="/kertakaynti">
            <SingleVisit openDoor="{false}"/>
        </Route>
        <Route path="/koodi">
            <SingleVisit openDoor="{false}"/>
        </Route>
        <Route path="/koodikaytetty">
            <SingleVisit openDoor="{true}"/>
        </Route>
        <Route path="/perjantailiiga">
            <FridayLeague/>
        </Route>
        <Route path="/kirjaudu">
            <LoginForm/>
        </Route>
        <Route path="/salasanaUnohtunut">
            <ForgotPasswordForm/>
        </Route>
        <Route path="/uusiSalasana/:hash" let:params>
            <NewPasswordForm hash="{params.hash}"/>
        </Route>
        <Route path="/uusiSalasana">
            <NewPasswordForm/>
        </Route>
        <Route path="/c/home">
            <CustomerHome/>
        </Route>
        <Route path="/c/gen">
            <GenerateWod/>
        </Route>
        <Route path="/c/oldGeneratedWods">
            <OldGeneratedWods/>
        </Route>
        <Route path="/c/fasting">
            <Fasting/>
        </Route>
        <Route path="/c/groupTrainings">
            <GroupTraining/>
        </Route>
        <Route path="/c/maxLifts">
            <MaxLifts/>
        </Route>
        <Route path="/c/fin">
            <FinStats/>
        </Route>
        <Route path="/c/finDailyMeal">
            <DailyMeal/>
        </Route>
        <Route path="/c/finHistory">
            <MealHistory/>
        </Route>
        <Route path="/c/finGoals">
            <Goals/>
        </Route>
        <Route path="/c/logout">
            <Logout/>
        </Route>

    </Router>
    <footer class="footerContainer">
        <Footer/>
    </footer>
</div>
